interface DayCheckinLogoProps {
  className?: string;
}

export function DayCheckinLogo({ className = 'w-10 h-10' }: DayCheckinLogoProps) {
  return (
    <svg
      viewBox="0 0 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="warmGlow" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#FFD93D" />
          <stop offset="100%" stopColor="#FF6B35" />
        </linearGradient>
        <mask id="horizonMask">
          <rect width="400" height="400" fill="white" />
          <circle cx="200" cy="680" r="430" fill="black" />
        </mask>
      </defs>
      <g mask="url(#horizonMask)">
        <circle cx="200" cy="270" r="140" fill="#FF6B35" opacity="0.08" />
        <circle cx="200" cy="270" r="110" fill="#FF8C42" opacity="0.15" />
        <circle cx="200" cy="270" r="84" fill="#FFD93D" opacity="0.25" />
        <circle cx="200" cy="270" r="64" fill="url(#warmGlow)" />
      </g>
    </svg>
  );
}
